"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

require("./Image.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stateless component to draw an image
 * @param {string} src path of the image.
 * @param {string} className wrapper class for img
 * @param {string} alt alt of the image.
 * @param {boolean} dynamicResize resize images
 * @returns {JSX} Component image JSX.
 */
const Image = props => {
  const myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  const {
    src,
    className,
    alt,
    align,
    dynamicResize,
    cySelector
  } = myProps;

  if (!src) {
    (0, _gerenciatdUtils.errorLog)('[Image]: src must be !== null');
  }

  let dynamicCssClass = '';
  let classNameCss = className ? `${className}` : ''; // align

  if (align !== 'none') {
    classNameCss = `${classNameCss} img_align--${align}`;
  }

  const currentOnLoad = img => {
    const {
      target
    } = img;
    const {
      width,
      height
    } = target;
    dynamicCssClass = height > width ? 'img--vertical' : 'img--horizontal';
    target.classList.add(dynamicCssClass);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    "cy-data": cySelector,
    className: classNameCss,
    alt: alt,
    src: src,
    onLoad: dynamicResize ? currentOnLoad : null
  });
};

Image.propTypes = {
  /**
   * {
   *  "info": "Dirección url de la imagen",
   *  "kind": "both",
   *  "beautifulName": "URL"
   * }
   */
  src: _propTypes.default.string.isRequired,

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Texto alternativo de la imagen",
   *  "kind": "both",
   *  "beautifulName": "Texto alternativo"
   * }
   */
  alt: _propTypes.default.string,

  /**
   * {
   *  "info": "Define si el tamaño de la imagen es dinámico",
   *  "kind": "both",
   *  "beautifulName": "Tamaño dinámico"
   * }
   */
  dynamicResize: _propTypes.default.bool,
  align: _propTypes.default.oneOf(['center', 'left', 'right', 'none']),

  /**
   * {
   *  "info": "Selector para cy-data",
   *  "kind": "both",
   *  "beautifulName": "Tamaño dinámico"
   * }
   */
  cySelector: _propTypes.default.string
};
Image.defaultProps = {
  className: '',
  alt: '',
  dynamicResize: false,
  align: 'none',
  cySelector: ''
};
var _default = Image;
exports.default = _default;

//# sourceMappingURL=index.js.map